import { Flex, Link, Heading, Strong, Text } from "@radix-ui/themes";

import { Callout, ShowMore } from "../../common/components";
import { Spinner } from "../../common/components/Spinner";

type VerificationPendingProps = {
  contactEmail: string;
};

export const VerificationPending = ({
  contactEmail,
}: VerificationPendingProps) => {
  return (
    <Flex
      style={{
        margin: "auto",
        height: "100%",
      }}
      p={"4"}
      direction={"column"}
      gap="4"
    >
      <Callout variant="surface" highContrast icon={<Spinner size="md" />}>
        <Flex direction="column" gap="2">
          <Heading size="3">Verification Pending</Heading>
          <Text size="2">
            We've sent a verification link to your contact email:{" "}
            <Strong>{contactEmail}</Strong>. Please check your inbox and click
            on the link to verify your account. This link will expire in 20
            minutes.
          </Text>
          <ShowMore showLabel={"Didn't receive the email?"} hideLabel={""}>
            <Text size="1" color="gray">
              Check your spam folder, just in case. Otherwise, please reach out
              at{" "}
              <Link href="mailto:support@potion.ai" size="1" color="blue">
                support@potion.ai
              </Link>
              .
            </Text>
          </ShowMore>
        </Flex>
      </Callout>
    </Flex>
  );
};
